import FillerWordsCommunication from '~/pages/communication/fillerWords/libs/components/FillerWordsCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const FillerWordsCommunicationPage = (props: TPageProps) => (
  <FillerWordsCommunication {...props} />
)

export default FillerWordsCommunicationPage
